module.exports = __webpack_public_path__ + "images/interview-FedEx-2.svg";